import { render, staticRenderFns } from "./DocumentsView.vue?vue&type=template&id=637baddd&scoped=true"
import script from "./DocumentsView.ts?vue&type=script&lang=js&external"
export * from "./DocumentsView.ts?vue&type=script&lang=js&external"
import style0 from "./DocumentsView.scss?vue&type=style&index=0&id=637baddd&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637baddd",
  null
  
)

export default component.exports